const SEARCH_BAR_STYLES = {
  COLUMN: 'COLUMN',
  ROW: 'ROW',
};

export { SEARCH_BAR_STYLES };
